import React, { useEffect, useState } from "react";
import { PiToggleRightFill, PiToggleLeftFill } from "react-icons/pi";
import { AiFillQuestionCircle } from "react-icons/ai";

import {
  FaArrowCircleLeft,
  FaArrowCircleRight,
  FaRegEdit,
  FaTrashAlt,
  FaRupeeSign,
  FaCheckCircle,
} from "react-icons/fa";
import { RiSaveFill } from "react-icons/ri";
import { IoLogoUsd } from "react-icons/io5";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { IoMailOpenOutline } from "react-icons/io5";

import ActiveSellerList from "../ActiveSellerList/ActiveSellerList";
import SellerDetailsForm from "../SellerSettings/Form Settings/Seller Details Form/SellerDetailsForm";
import SellerManagementDetails from "../SellerSettings/Form Settings/Seller Management Details/SellerManagementDetails";
import SellerBasicDetails from "../SellerSettings/Form Settings/Seller Basic Details/SellerBasicDetails";
import GeoDetails from "../SellerSettings/Form Settings/Geo Details/GeoDetails";
import ExecutivesDetails from "../SellerSettings/Form Settings/Executives/ExecutivesDetails";
import OtherBusinessDetails from "../SellerSettings/Form Settings/Other Business Details/OtherBusinessDetails";
import Security from "../SellerSettings/Form Settings/Security/Security";
import FileAttachments from "../SellerSettings/Form Settings/File Attachements/FileAttachements";

const UpdateSeller = () => {
  const location = useLocation();
  const { buyerData } = location.state || {};
  const [data, setData] = useState(buyerData || {});
  const [isEditing, setIsEditing] = useState(false);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [formData, setFormData] = useState({});
  const id = localStorage.getItem("id");
  const apiUrls = process.env.REACT_APP_API_URLS;
  const Nav = useNavigate();
  const [Showon, setShowon] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalSave, setShowModalSave] = useState(false);

  useEffect(() => {
    const fetchFields = async () => {
      try {
        const response = await axios.get(
          `${apiUrls}/buyer_settings/custom-fields/`
        );
        // const responseData = await axios.get(
        //   `${apiUrls}/addbuyer/buyer-details/${id}`
        // );
        setDynamicFields(response.data);
        // setData(responseData.data);
      } catch (error) {
        console.error("Error fetching buyer fields:", error);
      }
    };
    fetchFields();
  }, []);

  const handleFormChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handledelete = () => {
    setShowModal(false);
    Nav("/admin-dashboard/view-buyer/");
  };
  const handleSubmit = async () => {
    console.log(formData);
    setShowModalSave(false);
    Nav("/admin-dashboard/view-seller/");

    try {
      const response = await axios.post(
        `${apiUrls}/addbuyer/buyer-details/`,
        formData
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Buyer added successfully", {
          position: "top-right",
          autoClose: 600,
        });
        setTimeout(() => {
          window.location.reload();
        }, 700);
        // alert("Buyer added successfully");
        // Optionally, clear form or redirect to another page
      } else {
        // alert("Failed to add buyer");
        toast.error("Failed to add buyer", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    } catch (error) {
      // console.error("Error submitting form:", error);
      // alert("An error occurred while submitting the form.");
      toast.error("Buyer Email is Already Exist", {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };
  return (
    <div className="border-2 border-gray-200 mt-5  rounded-2xl px-5">
      <div className="border-b flex justify-between  items-center py-4 ">
        <h1 className="text-xl text-gray-600 font-semibold">Edit Seller</h1>
        <div className="flex items-center gap-4">
          <button className="flex gap-1 items-center bg-[#25d366] text-white px-4 py-2 rounded-md">
            <FaWhatsapp /> Whats App
          </button>
          <button className="flex gap-1 items-center bg-[#333333] text-white px-4 py-2 rounded-md">
            <BiPhoneCall /> Call
          </button>
          <div className="flex items-center border border-oceanBlue text-oceanBlue rounded-md">
            <span className="bg-oceanBlue py-2 px-2 text-white text-xl">
              <IoMailOpenOutline />
            </span>
            <button className="flex gap-1 items-center px-2">Send Email</button>
          </div>
        </div>
        <div>
          <div className="flex gap-2">
            <button
              className="bg-green-500 text-white p-2 text-xl rounded-md"
              onClick={() => setShowModalSave(true)}
            >
              <RiSaveFill className="text-white" />
            </button>

            <button
              onClick={() => setShowModal(true)}
              className="bg-blood p-2 rounded-md text-white text-xl"
            >
              {" "}
              <FaTrashAlt />
            </button>
          </div>
        </div>
      </div>

      <div className="flex gap-5 mt-5">
        <p
          onClick={() => setShowon(true)}
          className={`flex w-fit items-center gap-2 text-md font-medium cursor-pointer pb-1 border-b-[3px] ${
            Showon
              ? "text-blood border-blood"
              : "text-[#667085] border-transparent"
          }`}
        >
          Details
        </p>

        <p
          onClick={() => setShowon(false)}
          className={`flex w-fit items-center gap-2 text-md font-medium cursor-pointer pb-1 border-b-[3px] ${
            !Showon
              ? "text-blood border-blood"
              : "text-[#667085] border-transparent"
          }`}
        >
          Products
        </p>
      </div>

      {Showon ? (
        <>
          <div className="py-8 flex gap-5 justify-center">
            <p className="flex items-center bg-oceanBlue text-white px-4 py- rounded-md">
              Sellable Price of this Buyer in INR:{" "}
              <span>
                <FaRupeeSign />
              </span>{" "}
              0{" "}
            </p>
            <p className="flex items-center bg-oceanBlue text-white px-4 py-2 rounded-md">
              Sellable Price of this Buyer in USD:{" "}
              <span>
                <IoLogoUsd />
              </span>{" "}
              0{" "}
            </p>
          </div>
          <div className="flex flex-col gap-8">
            <SellerDetailsForm message={"actions not show"} />
            <SellerManagementDetails message={"actions not show"} />
            <SellerBasicDetails message={"actions not show"} />
            <GeoDetails message={"actions not show"} />
            <ExecutivesDetails message={"actions not show"} />
            <OtherBusinessDetails message={"actions not show"} />
            <FileAttachments message={"actions not show"} />
            <Security message={"actions not show"} />
          </div>
        </>
      ) : (
        <ActiveSellerList />
      )}
      <ToastContainer />
      {/* Modal */}
      {showModal && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col  py-5 text-center relative">
            <div className="flex w-full justify-center">
              <AiFillQuestionCircle className="text-6xl text-red-700 text-center" />
            </div>
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-md font-semibold">
                Do you want to delete this buyer contact ?
              </h3>
            </div>

            <div className="flex justify-center gap-5  ">
              <button
                onClick={() => setShowModal(false)}
                className="border border-b-teal-950 cousor-pointer text-red-700 px-4 py-1 rounded"
              >
                Cancel
              </button>
              <button
                onClick={() => handledelete()}
                className="bg-red-700  text-white px-4 py-1 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModalSave && (
        <div className="fixed  inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col  py-5 text-center relative">
            <div className="flex w-full justify-center">
              <FaCheckCircle className="text-6xl text-red-700 text-center" />
            </div>
            <div className="flex justify-center items-center mb-2">
              <h3 className="text-md text-center font-semibold">
                Buyer Saved Successfully
              </h3>
            </div>

            <div className="flex justify-center gap-5  ">
              <button
                onClick={() => handleSubmit()}
                className="bg-red-700  text-white px-4 py-1 rounded"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSeller;
